<template>
  <div>
    <sweet-modal
        :title="$t('settings_accountThink_GLAccounts_generallLedgerSubsidiary')"
        blocking
        ref="modal"
        class="modal"
        v-on:close="close">

      <el-row :gutter="20">
        <el-col :span="18" :offset="0">
          <h4 style="margin: 0px;">{{code + ' ' + title}}</h4>
          <el-date-picker
              style="margin-top: 10px"
              ref="datepicker"
              popper-class="custom-date-picker"
              size="mini"
              v-model="dates"
              class="datepicker"
              prefix-icon="el-icon-date"
              type="daterange"
              align="center"
              format="d MMM yy"
              :clearable="false"
              value-format="timestamp"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              @change="setFilter"
              :picker-options="pickerOptions"
          />
        </el-col>
        <el-col :span="6" :offset="0" style="text-align: right;"><h4 v-html="`${type}`" style="margin-top: 0px;"></h4></el-col>
      </el-row>

      <div style="position: absolute; top: 40px; right: 40px;">
        <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 27)">PDF</el-dropdown-item>
            <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 27)">XL
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,27)">Email</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <el-table
          :data="tableData"
          size="mini"
          border
          max-height="650"
          row-key="idTable"
          default-expand-all
          :row-class-name="tableRowClassName"
          style="width: 935px; margin-top: 20px"
          :empty-text="$t('general_noData')">
        <el-table-column
            fixed
            prop="transactionDate"
            width="220"
            label="Date">
          <!-- <template slot-scope="scope">
            {{scope.row.transactionDate ? moment(scope.row.transactionDate).format("D MMM YYYY") : scope.row.name  }}
          </template> -->
        </el-table-column>
        <el-table-column
            fixed
            label="ID#"
            align='center'
            width="130px">
          <template slot-scope="scope">
            <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.transactionNo}}</strong>
          </template>
        </el-table-column>
        <el-table-column
            label="Journal"
            width="110px">
          <template slot-scope="scope">
            {{scope.row.transactionType}}
          </template>
        </el-table-column>
        <el-table-column
            label="Type"
            width="110px">
          <template slot-scope="scope">
            {{scope.row.transactionType}}
          </template>
        </el-table-column>
        <el-table-column
            label="Description"
            width="100px">
          <template slot-scope="scope">
            {{scope.row.transactionDescription}}
          </template>
        </el-table-column>
        <el-table-column
            label="Debit"
            align="right"
            width="100px">
          <template slot-scope="scope">
            {{scope.row.debit && (scope.row.debit > 0) ? formatPrice(scope.row.debit) : null }}
          </template>
        </el-table-column>
        <el-table-column
            label="Credit"
            align="right"
            width="100px">
          <template slot-scope="scope">
            {{scope.row.credit && (scope.row.credit > 0) ? formatPrice(scope.row.credit) : null }}
          </template>
        </el-table-column>
        <el-table-column
            label="Balance"
            align="right"
            width="100px">
          <template slot-scope="scope">
            {{ scope.row.endingbalance && formatPrice(scope.row.endingbalance)}}
          </template>
        </el-table-column>
        <!-- <el-table-column
            label="Tax Amount"
            align="right"
            width="100px">
        </el-table-column>
        <el-table-column
            label="Allocated To"
            width="100px">
        </el-table-column>
        <el-table-column
            label="BU"
            width="100px">
        </el-table-column>
        <el-table-column
            label="WHS-ENG-PRO"
            width="110px">
        </el-table-column>
        <el-table-column
            label="Task"
            width="100px">
        </el-table-column>
        <el-table-column
            label="EU"
            width="100px">
        </el-table-column> -->
      </el-table>
    </sweet-modal>

    <editJournalEntryModal @updateList="getList" :showInfo="false" ref="editJournalEntryModal"/>
  </div>
</template>

<script>
import {SweetModal} from "@totalflow4/tfsweet-modal-vue";
import { Money, VMoney } from 'v-money'
import axios from 'axios'
import moment from 'moment'
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'
export default {
  name: "GeneralLedgerDetailedSubsidiaryModal",
  components: {
    SweetModal,
    editJournalEntryModal,
    Money
  },
  props: {
    params: {
      type: Object,
      default: () => ({
        data: {
          id: null,
          name: '',
          DRCRCode: 'DR',
          accountCurrencyId: null
        }
      })
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    }
  },
  directives: {money: VMoney},
  data() {
    return {
      moment: moment,
      tableData: [],
      dates: [],
      pickerOptions: {
        shortcuts: [
          {
            text: 'This month',
            onClick (picker) {
              const end = moment().endOf('month')
              const start = moment().startOf('month')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last month',
            onClick (picker) {
              const end = moment().endOf('month').subtract(1, 'months')
              const start = moment().startOf('month').subtract(1, 'months')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last 3 months',
            onClick (picker) {
              const end = moment().endOf('month').subtract(1, 'months')
              const start = moment().startOf('month').subtract(3, 'months')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'This financial quarter',
            onClick (picker) {
              const end = moment().endOf('quarter')
              const start = moment().startOf('quarter')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last financial quarter',
            onClick (picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter')
              const start = moment().subtract(1, 'quarter').startOf('quarter')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'This financial year',
            onClick (picker) {
              const end = moment().endOf('year')
              const start = moment().startOf('year')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last financial year',
            onClick (picker) {
              const end = moment().endOf('year').subtract(1, 'year')
              const start = moment().startOf('year').subtract(1, 'year')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  methods: {
    setFilter (val) {
      this.itemTest()
    },
    getList() {

    },
    itemTest() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/account/subsidiary-ledger?companyId=${this.$route.query.companyId}&accountId=${this.params.data.id}&startDate=${moment(this.dates[0], 'x').format('YYYY-MM-DD')}&endDate=${moment(this.dates[1], 'x').format('YYYY-MM-DD')}`).then(response => {

        let idTable = 1
        response.data.list.forEach((item) => {
          item.idTable = idTable
          idTable++
          item.transactionDate = item.name
          item.children.forEach((item) => {
            item.idTable = idTable
            idTable++
            if (item.transactionDate) {
              if (item.transactionDate !== 'Sub-Total') {
                item.transactionDate = moment(item.transactionDate).format("D MMM YYYY")
              }
            }
            item.amount = (+item.debit + +item.credit)
          })
        })

        // response.data.list.forEach(element => {
        //   if (element.isParent) element.transactionDate = element.name
        // });
        this.tableData = response.data.list
        loader.hide()
      })
    },
    openModal() {
      this.dates = [this.startDate, this.endDate]
      // this.dates = [moment(this.startDate).format("x"), moment(this.endDate).format("x")]
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/account/subsidiary-ledger?companyId=${this.$route.query.companyId}&accountId=${this.params.data.id}&startDate=${moment(this.dates[0], 'x').format('YYYY-MM-DD')}&endDate=${moment(this.dates[1], 'x').format('YYYY-MM-DD')}`)
          .then(response => {
            this.$refs.modal.open()

            let idTable = 1
            response.data.list.forEach((item) => {
              item.idTable = idTable
              idTable++
              item.transactionDate = item.name
              item.children.forEach((item) => {
                item.idTable = idTable
                idTable++
                if (item.transactionDate) {
                  if (item.transactionDate !== 'Sub-Total') {
                    item.transactionDate = moment(item.transactionDate).format("D MMM YYYY")
                  }
                }
                item.amount = (+item.debit + +item.credit)
              })
            })

            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    async exportData(typeExportId, typeId) {
      let email = null
      try {

        if (typeExportId === 3) {
          const { value } = await this.$prompt('Please input your e-mail', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Invalid Email'
          })
          email = value
        }
        const payload = {
          companyId: +this.$route.query.companyId,
          typeId: typeId,
          typeExportId: typeExportId,
          // startDate: this.financialYearStartDateFormatted ? this.financialYearStartDateFormatted : '2022-01-01',
          // endDate: moment().format('YYYY-MM-DD'),
          startDate: this.dates && this.dates[0] ? moment(this.dates[0], 'x').format('YYYY-MM-DD') : 'null',
          endDate: this.dates && this.dates[1] ? moment(this.dates[1], 'x').format('YYYY-MM-DD') : 'null',
          email: email,
          optionalField: {
            name: 'accountId',
            value: this.params.data.id.toString()
          }
        }
        let loader = this.$loading.show()
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
          axios.defaults.headers.common['X-Timezone-Offset'] = (new Date().getTimezoneOffset() / 60).toString()
          const { data } = await axios.post(`/api/v1/export`, payload)
          switch (typeExportId) {
            case 2: // pdf
            case 1: // xl
              window.open(data.file.downloadPath).focus()
              break
          }
        } catch (error) {
          console.log(error)
        } finally {
          loader.hide()
        }
      } catch (err) {
        console.log(err)
      }
    },
    tableRowClassName({row, rowIndex}) {
      if (row.isParent) return 'header-bg'
    },
    close(){
      console.log('close modal')
    },
    cellClickID(row){
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry({...row, id: row.transactionid})
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  }
}
</script>

<style lnag="scss" scoped>
/deep/.el-table .header-bg {
  background: #F5F7FA;
}
</style>
